import { applyMiddleware, combineReducers, createStore } from 'redux';
import { createLogger } from 'redux-logger';

import * as reducers from './reducers';

const DEV = process.env.REACT_APP_PROJECT_ID === 'bae-mingo-development';

const logger = createLogger({
  predicate: () => !!DEV,
  collapsed: (getState, action, logEntry) => !logEntry?.error,
});

const reducer = combineReducers(reducers);
const store = createStore(reducer, applyMiddleware(logger));
export default store;
